<template>
  <ul class="types">
    <li>
      <button
        class="types__button"
        :class="{ 'types__button--active': isAllSelected }"
        @click="handleTypeClick(null)"
      >
        All Stories
      </button>
    </li>
    <li v-for="_type in types" :key="_type.id">
      <button
        class="types__button"
        :class="{ 'types__button--active': isTypeSelected(_type) }"
        @click="handleTypeClick(_type)"
      >
        {{ _type.label }} ({{ _type.count }})
      </button>
    </li>
  </ul>
</template>

<script>
import isEqual from "lodash-es/isEqual";

export default {
  name: "BlogTypes",
  props: {
    types: {
      type: Array,
      default: () => [],
    },
    selectedType: {
      type: String,
      default: null,
    },
  },
  emits: ["change"],
  computed: {
    isAllSelected() {
      return this.selectedType === null;
    },
  },
  methods: {
    isTypeSelected(value) {
      return isEqual(this.selectedType, value.label);
    },
    handleTypeClick(value) {
      this.$emit("change", value ? value.label : value);
    },
  },
};
</script>

<style lang="scss" scoped>
.types {
  overflow: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  @include respond-above(md) {
    overflow: visible;
    white-space: normal;
    flex: 1 0 auto;
  }

  li {
    display: inline-block;

    &:first-child {
      .types__button {
        padding-left: 20px;
        @include respond-above(md) {
          padding-left: 0;
        }
      }
    }

    &:last-child {
      .types__button {
        padding-right: 16px;
      }
    }
  }

  &__button {
    background: none;
    outline: none;
    border: none;
    padding: 20px 8px;
    letter-spacing: 0.49px;
    opacity: 0.3;
    @include t__utility-label-20;

    &--active {
      font-weight: 600;
      opacity: 1;
      text-decoration: underline;
    }
  }
}
</style>
